export var ActionType;

(function (ActionType) {
  ActionType["GIVE"] = "give";
  ActionType["WITHDRAW"] = "withdraw";
})(ActionType || (ActionType = {}));

export var ConsentType;

(function (ConsentType) {
  ConsentType["PROSPECT"] = "prospect email list";
  ConsentType["SERVICE_PROSPECT"] = "service prospect email list";
  ConsentType["SERVICE_TERMS_AND_PRIVACY"] = "service terms & privacy";
  ConsentType["SUBKIT_TERMS_AND_PRIVACY"] = "subkit terms & privacy";
  ConsentType["SERVICE_EMAILS"] = "service emails";
  ConsentType["SERVICE_PAYMENT"] = "service payment";
  ConsentType["SERVICE_SUBSCRIPTION"] = "service subscription";
  ConsentType["RECOMMENDATION_EMAILS"] = "recomendation emails";
  ConsentType["PROVIDER_TERMS"] = "provider terms";
  ConsentType["SUBKIT_EMAILS"] = "subkit emails";
})(ConsentType || (ConsentType = {}));

export var ConsenterType;

(function (ConsenterType) {
  ConsenterType["PROSPECT"] = "prospect";
  ConsenterType["SUBSCRIPTION"] = "subscription";
  ConsenterType["SERVICE_PROSPECT"] = "service prospect";
  ConsenterType["SERVICE_CUSTOMER"] = "service customer";
  ConsenterType["USER"] = "user";
  ConsenterType["PROVIDER"] = "provider";
})(ConsenterType || (ConsenterType = {}));